const state = {
  list: [
    {
      name: 'RELATIONS INC.',
      img: 'clients/relations.jpg',
      link: "https://www.relationsgroup.co.jp/"
    },
    {
      name: 'Ohako inc.',
      img: 'clients/ohako.jpg',
      link: "https://ohako-inc.jp/"
    },
    {
      name: 'Altplus inc.',
      img: 'clients/altplus.png',
      link: "http://www.altplus.co.jp/"
    },
    {
      name: "Technofuturtic",
      img: "clients/technofuturtic.jpg",
      link: "http://www.technofuturtic.be/"

    },
    {
      name: "Hatte inc.",
      img: "clients/hatte.png",
      link: "https://www.hatte.co.jp/"
    },
    {
      name: "Excite One",
      img: "clients/exciteone.png",
      link: "https://exciteone.jp/"
    },
    {
      name: "Line",
      img: "clients/line.svg",
      link: "https://linecorp.com"
    },
  ]
};
const getters = {
  getClients: state => {
    return state.list;
  }
};

export default {
  state,
  getters
};



// WEBPACK FOOTER //
// ./src/store/clients.js